module.exports = "/_next/static/images/ben-kempner-f4d52c1639f5c02947b63a6dcc720817.jpg";